const template = require('./client_profile_changes_list.html.slim')
declare var angular
import { humanize } from 'extensions/helpers'

export class ClientProfileChangesList {
  static $inject = ['$rootScope', '$location', 'ClientProfileChanges']

  public clientProfileChanges
  // List of field types categories for the filter checklist
  // to be able to filter by changed field types
  public fieldTypes = [
    {value: "name", name: "Name"},
    {value: "address", name: "Address"},
    {value: "employment", name: "Employment"},
    {value: "marital", name: "Marital Status"},
    {value: "spouse_name", name: "Spouse Name"},
    {value: "spouse_employment", name: "Spouse Employment"},
  ]

  private clientProfileChangeResource
  private location
  private filters = { client: "", fieldsChanged: "" }
  private orderBy: string
  private reverse: string
  private page:    number
  private limit:   number

  constructor(private $rootScope, private $location, private ClientProfileChanges) {
    this.clientProfileChangeResource = ClientProfileChanges
    this.location = $location

    this.loadClientProfileChanges()

    $rootScope.$on('$routeUpdate', (() => {
      this.loadClientProfileChanges()
    }));
  }

  public humanizeChangeList(changes) {
    var humanizedChanges = []
    for (var change of changes) {
      humanizedChanges.push(humanize(change))
    }
    return humanizedChanges.join(", ")
  }

  private loadClientProfileChanges(): void {
    this.filters.client = ( this.location.search().client ? this.location.search().client : "")
    this.filters.fieldsChanged = (
      this.location.search().fieldsChanged ? this.location.search().fieldsChanged : ""
    )
    this.orderBy = this.location.search().orderBy
    this.reverse = this.location.search().reverse
    this.page = ( this.location.search().page ? this.location.search().page : 1 )
    this.limit = ( this.location.search().limit ? this.location.search().limit : 10 )

    this.clientProfileChangeResource.get({
      filters: this.filters,
      page: this.page,
      limit: this.limit,
      orderBy: this.orderBy,
      reverse: this.reverse
    }, (cpc) => {
      this.clientProfileChanges = cpc
    })
  }
}

angular.module('wbComponents').directive('clientProfileChangesList', function() {
  return {
    restrict: 'E',
    templateUrl: template,
    controller: ClientProfileChangesList,
    controllerAs: 'ctrl',
    bindToController: true,
  }
})
